import { css } from '@emotion/react';
import { extractShadow, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { Variants } from 'motion/react';

export const cardAnimationVariants: Variants = {
  initial: { opacity: 0, y: 10 },
  inView: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.11,
      duration: 0.66,
      ease: [0.22, 0.9, 0.53, 1],
      staggerChildren: 0.12,
    },
  },
  exit: {
    opacity: 0,
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: -14,
    border: 0,
    overflow: 'hidden',
    transition: { duration: 0.33, ease: [0.22, 0.9, 0.53, 1] },
  },
};

const styles = {
  card: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 16px;
    flex-shrink: 0;
    min-width: 400px;
    background: white;

    border: 1px solid ${theme.colors.neutral.variant[10]};
    border-radius: 14px;

    overflow: hidden;
    box-shadow: ${extractShadow((s) => s.robin2)};

    ${extractTransition((t) => t.cubic, {
      duration: 330,
      property: ['box-shadow', 'background-color', 'border-color', 'border-width'],
    })}

    &:hover {
      box-shadow: ${extractShadow((s) => s.large)};
      background-color: ${theme.colors.neutral.variant[5]};
      cursor: pointer;
      user-select: none;
    }
  `,
  cardSelected: ({ theme }) => css`
    border-width: 1.5px;
    border-color: ${theme.colors.primary.fuchsia[40]};
    background-color: ${theme.colors.neutral.variant[5]};

    &,
    &:hover {
      box-shadow: unset;
      cursor: default;
    }
  `,
  skeletonList: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0 14px;
    gap: 14px;
  `,
  skeleton: css`
    pointer-events: none;
  `,
  divisor: css`
    margin: 12px 0;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  footer: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  sectionTitle: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  bestMatchRate: css`
    margin-left: auto;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
